import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
/* componentes visuales */
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import FormControl from '@material-ui/core/FormControl';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import withStyles from '@material-ui/core/styles/withStyles';
import TextField from '@material-ui/core/TextField';
import IpmIcon from "../../images/PEMS_logo.png";
import Link from '@material-ui/core/Link';
import history from '../../common/history';


/*Styling */
const styles = theme => ({
  "@global":{
    body:{
      backgroundColor:"#2E343F"
    }
  },
  main: {
    width: 'auto',
    display: 'block', // Fix IE 11 issue.
    marginLeft: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3,
    [theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
      width: 400,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: theme.spacing.unit * 21,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
  },
  avatar: {
    backgroundColor: "white",
    margin:0,
    width:theme.spacing.unit*12,
    height:theme.spacing.unit*12,
    minWidth:80, 
    minHeight:80
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing.unit,
  },
  submit: {
    marginTop: theme.spacing.unit * 3,
  },
   myinput: {
     root:{
        '& label.Mui-focused': {
        color: 'green',
      },
      '& .MuiInput-underline:after': {
        borderBottomColor: 'green',
      },
      '& .MuiOutlinedInput-root': {
        '& fieldset': {
          borderColor: 'red',
        },
        '&:hover fieldset': {
          borderColor: 'yellow',
        },
        '&.Mui-focused fieldset': {
          borderColor: 'green',
        },
      },
     }
  },
});


const CssTextField = withStyles({
  root: {
    '& label.Mui-focused': {
      color: 'green',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: 'green',
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: 'red',
      },
      '&:hover fieldset': {
        borderColor: 'yellow',
      },
      '&.Mui-focused fieldset': {
        borderColor: 'green',
      },
    },
  },
})(TextField);


//funcion que obtiene el token
let getParams=(location)=> {
  const searchParams = new URLSearchParams(location.search);
  return {
    token: searchParams.get('token') || '',
  };
}


 class ChangePasswordView extends Component {
  constructor(props) {
    super(props)
  
    this.state = {
        usuario:{
        password:"",
        passwordConfirmation:""
        },
       token:"",
       errores:{
       }, 
       passwordValid:false,
       passwordConfirmationValid:false,
    }
    this.handleChange = this.handleChange.bind(this);
    this.changePassword=this.changePassword.bind(this);
    this.goToLogin=this.goToLogin.bind(this);
  }
  handleChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    let usuario = this.state.usuario;
    usuario[name] = value;
    this.setState({ 
      usuario: usuario,
    });
    this.validateForm();
  }
  
  componentWillMount(){
    let receivedToken= getParams(window.location)
    if(receivedToken.token.length>0){
      this.setState({
        token:receivedToken.token
      })
    }
  }
  validateForm = () => {
    let errores={
      password:{},
      passwordConfirmation:{}
    };
    let formValid = true;
    if (!this.state.usuario || !this.state.usuario.password || this.state.usuario.password.length < 1) {
      errores.password.message = 'Must enter your password';
      formValid = false;
    }
    if (
      !this.state.usuario ||
      !this.state.usuario.passwordConfirmation ||
      this.state.usuario.passwordConfirmation.length < 1 ||
      this.state.usuario.passwordConfirmation!== this.state.usuario.password
    ) {
      errores.passwordConfirmation.message = "Confirmation does not match with password";
      formValid = false;
    }
    this.setState({
      errores: errores,
      formValid: formValid,
    });
  };
  changePassword=()=>{
    if(this.state.formValid&&this.state.token.length>1){
      let passwordInfo={
        token:this.state.token, 
        password:this.state.usuario.password
      }
      this.props.changePassword(passwordInfo)
      this.props.setChangePasswordLoading()
    }
  }
  goToLogin=()=>{
    history.push('/login')
  }

  render() {
    const { classes } = this.props;
    return (
      <main className={classes.main} >
        <div >
            <CssBaseline />
            <Paper className={classes.paper}>
                <Avatar className={classes.avatar} src={IpmIcon} style={{marginBottom:'0%',/* minWidth:80, minHeight:80,*/ borderRadius:0}} variant="square">
                </Avatar>
                <Typography component="h1" variant="h5" style={{color:"#5a6271"}}>
                  Enter your new password.
                </Typography>
              <form className={classes.form}>
                {this.props.changePasswordLoading===0?
                <div>
                <FormControl margin="normal" required fullWidth className={classes.myroot}>
                  <CssTextField
                    label="Password"
                    variant="outlined"
                    heap-ignore='true'
                    name="password" type="password" id="password" autoComplete="current-password" 
                    value={this.state.usuario.password ? this.state.usuario.password : ''}
                    onChange={this.handleChange}
                    error={this.state.errores.password ?this.state.errores.password.message? true : false:false}
                    style={{borderColor:"red !important", color:"red"}}
                  />
                </FormControl>            
                <br/>
                <span style={{color:"red",fontSize:"0.8em"}}>{this.state.errores.password? this.state.errores.password.message:""}</span>
                <br/>
                <FormControl margin="normal" required fullWidth className={classes.myroot}>
                  <CssTextField
                    label="Password confirmation"
                    heap-ignore='true'
                    variant="outlined"
                    name="passwordConfirmation" type="password" id="passwordConfirmation" autoComplete="current-password-confirmation" 
                    value={this.state.usuario.passwordConfirmation ? this.state.usuario.passwordConfirmation : ''}
                    onChange={this.handleChange}
                    error={this.state.errores.passwordConfirmation ? this.state.errores.passwordConfirmation.message ? true : false:false}
                    style={{borderColor:"red !important", color:"red"}}
                  />
                </FormControl>
                <br/>
                <br/>
                <span style={{color:"red", fontSize:"0.8em"}}>{this.state.errores.passwordConfirmation? this.state.errores.passwordConfirmation.message:""}</span>
              </div>
                : 
                <div>                    
                  <span style={{color:"green", marginLeft:"25px"}}>{this.props.changePasswordLoading>0?"Your password has been updated.":""}</span>
                  <br />
                  <br />
                  <div style={{marginLeft:"25px"}}>
                    <Link
                      component="button"
                      variant="body2"
                      onClick={() => {
                       this.goToLogin()
                      }}
                    >Please Log in.</Link>
                  </div>
                </div>
                }
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                  onClick={this.changePassword}     
                  disabled={!this.state.formValid|| this.props.changePasswordLoading>0}           
                >
                  Change password
                </Button>
              </form>
            </Paper>
          </div>
        </main>
    );
  }
}
/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    login: state.login,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    
  };
}


ChangePasswordView.propTypes = {
  classes: PropTypes.object.isRequired,
};


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(ChangePasswordView));


// WEBPACK FOOTER //
// ./src/features/login/ChangePasswordView.js